import React, { Component } from 'react';

class KinkiTop extends Component {
  render() {
    return (
      <div className="Kinki-top pref">
        <div>兵庫</div>
        <div>京都</div>
        <div>滋賀</div>
      </div>
    );
  }
}

class KinkiMid extends Component {
  render() {
    return (
      <div className="Kinki-mid pref">
        <div>大阪</div>
        <div>奈良</div>
        <div>三重</div>
      </div>
    );
  }
}

class KinkiBot extends Component {
  render() {
    return (
      <div className="Kinki-bot pref">
        <div>和歌山</div>
      </div>
    );
  }
}

class Kinki extends Component {

  render() {

    return (
      <div className="Kinki">
        <KinkiTop />
        <KinkiMid />
        <KinkiBot />
      </div>
    );
  }

}

export default Kinki;
